export const DEFAULT_VALUES = {
  year: null,
  make: null,
  model: null
}

export const IDS = {
  make: 'make',
  model: 'model'
}